import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { SLIM_SCROLLBAR_CLASS } from '@/styles/scrollbar';

const DESKTOP_MIN_TABLE_HEIGHT_CLASS = 'lg:min-h-72';

interface TableScrollFrameProps {
  className?: string | undefined;
  children: ReactNode;
}

export function TableScrollFrame({ className, children }: TableScrollFrameProps) {
  return (
    <div
      className={cn(
        'flex flex-col w-full rounded-2xl bg-card ring-1 ring-primary/12',
        DESKTOP_MIN_TABLE_HEIGHT_CLASS,
        className,
      )}
      style={{ overflow: 'clip' }}
    >
      <div className={cn('min-h-0 flex-1 overflow-auto', SLIM_SCROLLBAR_CLASS)}>{children}</div>
    </div>
  );
}
